import { Button, Center, Checkbox, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TReplyValuesDataTableData = {
    condition: {
        resp: string,
        tick: string,
        diary: string,
        cash: string,
        seq: string,
    },
    result: {
        type: boolean,
        stateNum: string,
        screenNum: string,
        func: string,
        receipt: string,
        diary2: string,
    },
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<TReplyValuesDataTableData>()

export function getReplyValuesDataTableColumns({ isLoading, handleEdit }: Props) {
  
  return [
      
    columnHelper.group({
        header: "Condition",
        columns: [
            columnHelper.accessor("condition.resp",
                {
                    id: "resp",
                    header: "Resp.",
                    cell: (props) => {
                        return (<Skeleton isLoaded={!isLoading}>
                            <Center>{props.getValue()}</Center>
                        </Skeleton>)
                    },
                }
            ),
            columnHelper.accessor("condition.tick",
                {
                    id: "tick",
                    header: "Tick",
                    cell: (props) => {
                        return (<Skeleton isLoaded={!isLoading}>
                            {props.getValue()}
                        </Skeleton>)
                    },
                }
            ),
        
            columnHelper.accessor("condition.diary",
                {
                    id: "diary",
                    header: "Journal",
                    cell: (props) => {
                        return (<Skeleton isLoaded={!isLoading}>
                            {props.getValue()}
                        </Skeleton>)
                    },
                }
            ),
        
            columnHelper.accessor("condition.cash",
                {
                    id: "cash",
                    header: "Cash",
                    cell: (props) => {
                        return (<Skeleton isLoaded={!isLoading}>
                            {props.getValue()}
                        </Skeleton>)
                    },
                }
            ),
        
            columnHelper.accessor("condition.seq",
                {
                    id: "seq",
                    header: "Seq.",
                    cell: (props) => {
                        return (<Skeleton isLoaded={!isLoading}>
                            {props.getValue()}
                        </Skeleton>)
                    },
                }
            ),

        ]
    }),

    columnHelper.group({
        header: "Résultat",
        columns: [
            columnHelper.accessor("result.type", 
                {
                    header: () => {
                        return (
                            <Skeleton isLoaded={!isLoading}>
                                <Center>Type</Center>
                            </Skeleton>
                        )
                    },
                    cell: (props) => {
                        return (<Skeleton isLoaded={!isLoading}>
                            <Center>
                                <Checkbox isChecked={!!props.getValue()}></Checkbox>
                            </Center>
                        </Skeleton>)
                    },

                }
            ),
            columnHelper.accessor("result.stateNum", 
                {
                    header: () => {
                        return (
                            <Skeleton isLoaded={!isLoading}>
                                <Center>State Num.</Center>
                            </Skeleton>
                        )
                    },
                    cell: (props) => {
                        return (<Skeleton isLoaded={!isLoading}>
                            <Center>{props.getValue()}</Center>
                        </Skeleton>)
                    },

                }
            ),
            columnHelper.accessor("result.screenNum", 
                {
                    header: () => {
                        return (
                            <Skeleton isLoaded={!isLoading}>
                                <Center>Screen Num.</Center>
                            </Skeleton>
                        )
                    },
                    cell: (props) => {
                        return (<Skeleton isLoaded={!isLoading}>
                            <Center>{props.getValue()}</Center>
                        </Skeleton>)
                    },

                }
            ),
            columnHelper.accessor("result.func", 
                {
                    header: () => {
                        return (
                            <Skeleton isLoaded={!isLoading}>
                                <Center>Func.</Center>
                            </Skeleton>
                        )
                    },
                    cell: (props) => {
                        return (<Skeleton isLoaded={!isLoading}>
                            <Center>{props.getValue()}</Center>
                        </Skeleton>)
                    },

                }
            ),
            columnHelper.accessor("result.receipt", 
                {
                    header: () => {
                        return (
                            <Skeleton isLoaded={!isLoading}>
                                <Center>Receipt</Center>
                            </Skeleton>
                        )
                    },
                    cell: (props) => {
                        return (<Skeleton isLoaded={!isLoading}>
                            <Center>{props.getValue()}</Center>
                        </Skeleton>)
                    },

                }
            ),
            columnHelper.accessor("result.diary2", 
                {
                    header: () => {
                        return (
                            <Skeleton isLoaded={!isLoading}>
                                <Center>Journal</Center>
                            </Skeleton>
                        )
                    },
                    cell: (props) => {
                        return (<Skeleton isLoaded={!isLoading}>
                            <Center>{props.getValue()}</Center>
                        </Skeleton>)
                    },

                }
            ),
        ]
    }),

    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center>
                        <Button
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}
                            mr={'1rem'}
                        >
                            Editer
                        </Button>
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
